export default "__VITE_ASSET__dRwPxq$b__"